module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCond-Bold.b8e49433.ttf";